// decorators/onlyClient.ts
import { A } from "../env-info.js";
var onlyClient = (target, propertyName, descriptor) => {
  const originalValue = descriptor.value;
  if (typeof originalValue !== "function")
    throw new Error("@onlyClient can only be used on functions " + propertyName);
  descriptor.value = function() {
    if (A.isServer)
      throw new Error(`${propertyName} can only be called on the client.`);
    return originalValue.apply(this, arguments);
  };
  return descriptor;
};
export {
  onlyClient
};
